import { getTelegramInitData } from './telegram';

function baseUrl() {
  const raw = (import.meta as any).env?.VITE_API_BASE_URL;
  return String(raw || '').replace(/\/$/, '');
}

function makeUrl(path: string) {
  const p = String(path || '');
  if (!p.startsWith('/')) return `${baseUrl()}/${p}`;
  return `${baseUrl()}${p}`;
}

async function request<T>(method: string, path: string, body?: any): Promise<T> {
  const initData = getTelegramInitData();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (initData) {
    headers['X-Tg-Init-Data'] = initData;
  }

  const res = await fetch(makeUrl(path), {
    method,
    headers,
    body: body == null ? undefined : JSON.stringify(body),
    credentials: 'include',
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `HTTP ${res.status}`);
  }

  const ct = res.headers.get('content-type') || '';
  if (ct.includes('application/json')) {
    return (await res.json()) as T;
  }
  return (await res.text()) as unknown as T;
}

export function apiGet<T = any>(path: string): Promise<T> {
  return request<T>('GET', path);
}

export function apiPost<T = any>(path: string, body?: any): Promise<T> {
  return request<T>('POST', path, body);
}
